import { MessageSquare } from 'lucide-react';
import ChatBindingCard, { type ChatBindingStatus } from './ChatBindingCard';
import { orgMaxApi, type OrgMaxStatus } from '../api/max';

interface Props { orgId: string }

/** MAX-чат: тонкая обёртка над ChatBindingCard. */
export default function OrgMaxChatCard({ orgId }: Props) {
  const adapt = (s: OrgMaxStatus): ChatBindingStatus => ({
    enabled: s.enabled, linked: s.linked,
    chat_id: s.chat_id, bot_username: s.bot_username,
    pending_code: s.pending_code, pending_expires_at: s.pending_expires_at,
  });
  return (
    <ChatBindingCard
      title="MAX-чат"
      channel="max"
      icon={<MessageSquare size={11} />}
      accentClass="text-orange-400"
      buttonClass="bg-orange-600 hover:bg-orange-500"
      startCommandUrlPrefix="https://max.ru/"
      api={{
        status: () => orgMaxApi.status(orgId).then(adapt),
        link: () => orgMaxApi.link(orgId).then(() => {}),
        unlink: () => orgMaxApi.unlink(orgId).then(() => {}),
      }}
    />
  );
}
